import { jsx } from 'react/jsx-runtime';
import { createContext, useRef } from 'react';
import { displayContents } from '../styles/composables.css.js';

/**
 * Context for managing popover refs and will make sure that all floating elements load within this ref
 */
const PopoverOutletContext = createContext(undefined);
/**
 * Helper component that provides a outlet provider and initializes it to a div within this component
 */
function PopoverOutlet({ children }) {
    const providerRef = useRef(null);
    return (jsx("div", { "data-fpl-component": "", className: displayContents, ref: providerRef, children: jsx(PopoverOutletContext.Provider, { value: providerRef, children: children }) }));
}
PopoverOutlet.displayName = 'PopoverOutlet';

export { PopoverOutlet, PopoverOutletContext };
//# sourceMappingURL=popover-outlet.js.map
